(ns nosco.ui.base
  "A collection of very very basic components that are needed even in main."
  (:require
   ["react" :as React]
   ["react-useportal" :default usePortal]
   [hx.hooks :as hooks]
   [hx.react :refer [defnc]]
   [nosco.polyfills]
   [nosco.react :as nosco-react]
   [nosco.util :as util]))

(defnc NewStackingContext [{:keys [children] :as props}]
  ;; https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
  [:div (nosco-react/merge-props
         {:style {:isolation "isolate"}}
         props)
   children])

;; Modals have an issue with the rendering order of react
;; if you let the default behaviour of justing appending to document.body
;; then you're bound to end up with a situation where the Portal <divs>
;; end up out of order (eg. if you remove the parent of a Portal from the DOM),
;; and add it again, then it will end up at the bottom of the body, therefore
;; above everything else... there's more scenarios like this.

;; therefore what we do is we try to align the React tree with the portals order.
;; We create a hierarchy of ContextProviders so that each portal root follows
;; its parent anchor in the DOM. Roots inside native dialogs must stay inside
;; the dialog's top layer.

;; Snags: we rely on the same z-index for all, so we can't use a z-index 2
;; in the modals3 approach.

(defonce ModalManagerContext (React/createContext nil))

(defn use-create-modal-root [previous-dom]
  (let [root-ref (React/useRef)]
    (hooks/useLayoutEffect
     (fn []
       (let [div (.createElement js/document "div")
             parent (if previous-dom (.-parentNode previous-dom) js/document.body)]
         (assert parent "Modal portal anchor must be mounted")
         (if previous-dom
           (.insertBefore parent div (.-nextSibling previous-dom))
           (.appendChild parent div))
         (.setAttribute div "class" (util/genid "modal-manager"))
         (set! (.-current root-ref) div)
         (fn []
           (.removeChild parent div))))
     [])

    root-ref))

(defnc ModalManager [{:keys [children]}]
  (let [previous-dom (hooks/useContext ModalManagerContext)
        root-ref (use-create-modal-root (when previous-dom (.-current previous-dom)))]
    [:provider {:context ModalManagerContext
                :value root-ref}
     children]))

(defnc ModalPortal [{:keys [children]}]
  (let [dom-ref (hooks/useContext ModalManagerContext)
        Portal (.-Portal (usePortal #js {:bindTo (.-current dom-ref)}))]
    [Portal
     [ModalManager
      children]]))

(defonce base-site-title (atom "Nosco"))
(defn set-base-site-title! [base-title]
  (reset! base-site-title base-title)
  (set! (.-title js/document) base-title))

(defn use-set-title [title]
  (hooks/useEffect
   (fn []
     (when title
       (let [prev-title (.-title js/document)]
         (set! (.-title js/document) (str title " | " @base-site-title))
         #(set! (.-title js/document) prev-title))))
   [title]))
